var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App---Signup-/-Login-(WIP)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ONB-/-Vertical_ES-Copy",
    transform: "translate(-263, -664)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-copy",
    transform: "translate(20, 645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-facebook-6",
    transform: "translate(243, 19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1166667,0 L0.883333333,0 C0.395333333,0 0,0.395333333 0,0.883333333 L0,15.1173333 C0,15.6046667 0.395333333,16 0.883333333,16 L8.54666667,16 L8.54666667,9.804 L6.46133333,9.804 L6.46133333,7.38933333 L8.54666667,7.38933333 L8.54666667,5.60866667 C8.54666667,3.542 9.80866667,2.41666667 11.6526667,2.41666667 C12.536,2.41666667 13.2946667,2.48266667 13.516,2.512 L13.516,4.672 L12.2373333,4.67266667 C11.2346667,4.67266667 11.0406667,5.14933333 11.0406667,5.848 L11.0406667,7.39 L13.432,7.39 L13.1206667,9.80466667 L11.0406667,9.80466667 L11.0406667,16 L15.118,16 C15.6046667,16 16,15.6046667 16,15.1166667 L16,0.883333333 C16,0.395333333 15.6046667,0 15.1166667,0 L15.1166667,0 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1f90856d9da4d07599a563969bdbcddf.svg";
export { ForwardRef as ReactComponent };